import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Stats from './components/Stats';
import HowItWorks from './components/HowItWorks';
import Services from './components/Services';
import Industries from './components/Industries';
import WhyUs from './components/WhyUs';
import CtaBanner from './components/CtaBanner';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="app">
      <Header />
      <Hero />
      <Stats />
      <HowItWorks />
      <Services />
      <Industries />
      <WhyUs />
      <CtaBanner />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
